// extracted by mini-css-extract-plugin
export default {"container":"TableFooter_container__nVBBX","results":"TableFooter_results__Rb4+v"};